import Button from "@mui/material/Button";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";

//import  NotificationSnackBar  from "../../components/NotificationSnackbar";
import { AuthAPI } from "../../api/AuthAPI";
import { AuthContext } from "./AuthContext";
import otpImg from '../../assets/images/otp.png'
import ReCAPTCHA from "react-google-recaptcha";


const MemberVerification = () => {
  const {signIn, isLoading, setMessage, setIsLoading } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  let stateObj = location?.state;
  const [code, setCode] = useState("")

  const handleCode = (e) => {
    setCode(e);
  };
  if (!stateObj) {
    navigate("/login");
  }
  const login=async()=>{
    await signIn(stateObj?.userName?.trim(), stateObj?.password?.trim());
    if(stateObj?.token){
      navigate("/events");
    }else{
      navigate("/");
    }
  }
  const handleActivateMember = async (e) => {
    e.preventDefault();
    setMessage({ type: '', content: '' });
    const currentUser = stateObj?.userName;

    if (!code || code?.length < 6) {
      return;
    }

    try {

      const confirmData = {
        token: code,
        userName: currentUser
      }
      setIsLoading(true);
      await AuthAPI.confirmSignUp(confirmData);
      setIsLoading(false);
      setMessage({ type: 'success', content: 'Your email is verified. Please log in' });
      if(stateObj?.token){
        login();
      }else{
        navigate("/login", { replace: true });
      }
    } catch (err) {
      setIsLoading(false);
      setMessage({ type: 'error', content: err?.response?.data?.Data });
    }
  }

  const verifyCaptcha = async (data) => {
    try {
      const response = await AuthAPI.postVerifyCaptcha(data);
      setCaptchaVerified(response.Data);
    } catch (error) {

    }
  }
  return (
    <div className="otp_verification_container">
      <div className="otp_verification_field">
        <img src={otpImg} alt="" />
        <h2>Verify Your Email</h2>
        <p>
          A confirmation code has been sent to your email address <span>{stateObj?.userName}</span>. To activate the account and validate your email, enter the code below.
        </p>
        <form className="otp_validate_input" noValidate>
          <VerificationInput
            autoFocus={true}
            classNames={{
              container: "container",
              character: "character",
              characterInactive: "character--inactive",
              characterSelected: "character--selected",
              characterFilled: "character--filled",
            }}
            length={6}
            onChange={(e) => handleCode(e)}
          />
          <ReCAPTCHA
            style={{ alignSelf: 'center' }}
            className="re-captcha"
            sitekey={`${import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}`}
            onChange={(data) => verifyCaptcha(data)}
          />
          <div className="otp_validate_btn">
            <Button
              type="submit"
              fullWidth
              disabled={!captchaVerified}
              variant="contained"
              onClick={handleActivateMember}
            >
              Verify
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberVerification;